export default class GetWarehouseCostPoolsRequest {
    public warehouseId: string = "";
    
    public showDeleted: boolean = false;
}